import { FC } from 'react'
import { PagingEnum } from '../types'

interface LinkProps {
  item: {
    url: string
    name: string
    icon?: React.ReactNode
    noList?: boolean
  }
  id?: string
  index: number
  checkActive: (url: string) => boolean
  navigate: (url: string) => void
}

const Link: FC<LinkProps> = ({ item, index, checkActive, navigate }) => {
  const navigatePath = `${item.url}${
    !item.noList
      ? `?page-index=${PagingEnum.DEFAULT_PAGE_INDEX}&page-size=${PagingEnum.DEFAULT_PAGE_SIZE}`
      : ''
  }`
  return (
    <a
      href={`${window.location.origin}${navigatePath}`}
      onClick={(ev) => {
        ev.preventDefault()
        navigate(navigatePath)
      }}
      key={index}
      className={`bf-link item ${checkActive(item.url) ? 'active' : ''}`}
    >
      {item.name}
    </a>
  )
}

export default Link
